import styled from "styled-components";

export const transparentSecondaryButtonStyles = {
  backgroundColor: "transparent",
  hoverBackgroundColor: "transparent",
  activeBackgroundColor: "transparent",
  disabledBackgroundColor: "transparent",
};

export const SkillsSection = styled.div`
  width: 100%;
  margin-top: 8px;
`;

export const SkillsInputRow = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-end;
  gap: 12px;
`;

export const SkillsInputFieldWrap = styled.div`
  flex: 1 1 auto;
  max-width: calc(100% - 120px);
`;

export const SkillsAddButtonWrap = styled.div`
  flex: 0 0 auto;
  white-space: nowrap;
  margin-bottom: 10px;
`;

export const SkillsTags = styled.div`
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;
